import { Navigate, useLocation } from 'react-router';

// The redirect URI registered on the Ibanity application; Ponto's query
// (code/state or error) is handled on the Bank Sync page.
export default function PontoCallbackPage() {
  const { search } = useLocation();
  return <Navigate to={`/app/admin/ponto${search}`} replace />;
}
